(ns ductile.service.label
  (:require [ductile.service.code :as service.code]
            [ductile.ui.locale :as locale :refer [tr]]))

(defn template-quantity-str
  [{:as service :requested/keys [fuel-liters fuel-percentage charge-percentage charge-kwh pressure-bar]}]
  (cond
    fuel-liters (str fuel-liters " " (tr :unit/liter))
    fuel-percentage (str fuel-percentage " %")
    charge-percentage (str charge-percentage " %")
    charge-kwh (str charge-kwh " " (tr :unit/kwh))
    pressure-bar (str pressure-bar " " (tr :unit/bar))))

(defn template-quantity [{:as service :service/keys [quantity unit]}]
  (if quantity
    (cond-> (str " " quantity)
      unit (str " " (tr unit)))
    (str " " (template-quantity-str service))))

;;should really use ISO Locales everywhere for translations instead
(def locale->country-code
  {:en "ENG"
   :de "DEU"
   :it "ITA"})

(defn service-code [service]
  (or (:service/code service)
      (get-in service.code/id->country-code->service-code
              [(-> service :service/template :service/id)
               (locale->country-code (locale/get-current-locale))])))

(defn service-label [service]
  (cond-> (str (service-code service) (template-quantity service))
    (:service/detail service) (str " " (:service/detail service))
    (-> service :ductile/file-attachment :file/name) (str " (" (-> service :ductile/file-attachment :file/name) ")")
    (:new-contract/name service) (str " (" (:new-contract/name service) ")")))

(defn order-service-label [service]
  (cond-> (str (:service/code service) (template-quantity service))
    (:service/detail service) (str " " (:service/detail service))
    (string? (:service/contract service)) (str " (" (:service/contract service) ")")))
